import isFunction from 'lodash/isFunction';
// These should only loaded if the browser doesn't support them, once we have dynamic imports
// we should rewrite these https://github.com/thebuilder/react-intersection-observer#polyfill
import 'react-app-polyfill/ie11';
import 'intersection-observer';
import './elementClosest';

// Core.js polyfills
import 'core-js/es/string/starts-with';
import 'core-js/es/array';
import 'core-js/es/array/flat';
import 'core-js/es/map';
import 'core-js/es/object/entries';
import 'core-js/es/object/values';
import 'core-js/stable/url';

// IE 11 doesn't implement Number.isFinite so only load when it's present
if (isFunction(Number.isFinite)) {
  require('delayed-scroll-restoration-polyfill');
}
